import { useState } from 'react';
import { useChartStore } from '@/store/chartStore';
import { SearchIcon } from '@/components/icons';
import { SymbolSearchModal } from './SymbolSearchModal';

export function SymbolSearch() {
  const symbol = useChartStore((s) => s.symbol);
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        title="Search symbol"
        className="flex items-center gap-1.5 bg-bg border border-border rounded px-2 h-7 min-w-[110px] flex-1 md:flex-none md:min-w-[160px] hover:border-accent transition-colors"
      >
        <SearchIcon size={13} className="text-muted shrink-0" />
        <span className="text-text text-base font-semibold truncate">{symbol}</span>
      </button>
      {open && <SymbolSearchModal onClose={() => setOpen(false)} />}
    </>
  );
}



